import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { Location } from '@angular/common';
import { ManpowerrecruitmentService } from 'src/app/services/manpowerrecruitment.service';

@Component({
  selector: 'app-confirmtools',
  templateUrl: './confirmtools.component.html',
  styleUrls: ['./confirmtools.component.css']
})
export class ConfirmtoolsComponent implements OnInit {
  token: string="";
  constructor( private sanitizer: DomSanitizer,  private location:Location ,  private route: ActivatedRoute,  private tokenService: TokenService, private router: Router,
    private notification: NotificationService, private _ActivatedRoute: ActivatedRoute , private recruitmentService:ManpowerrecruitmentService) { }

  ngOnInit(): void {
    this.route.queryParams
    .subscribe(params => {
      console.log(params);  
      this.token = params.to;
      console.log(this.token);  
    }
  );

  if(this.token.length==0)
  {
    this.router.navigate(['/approverequests']);

  }

 
this.LoadData();
   this.location.replaceState(this.location.path().split('?')[0], '');
  


  var snapshot = this._ActivatedRoute.snapshot;
  const params = { ...snapshot.queryParams };
  delete params.pos
  this.router.navigate([], { queryParams: params });
}


async LoadData()
{
  
  
  var x = { token: this.token };
  let resLo = await this.recruitmentService.CompleteToolRequest(x).toPromise();
  
  if(resLo.responseCode)
  {

  }








}


cancel()
{
 this.router.navigateByUrl('/dashboard');
// this.router.navigate(['/dashboard']);
}
}
